import React, { useState, useEffect } from "react";
import { createConversation, getConversation, sendMessage, sendMessageStream, switchToHuman } from "../api";
import MessageInput from "./MessageInput";

export default function ChatWindow({ conversationId: initialConversationId }) {
  const [conversationId, setConversationId] = useState(initialConversationId);
  const [messages, setMessages] = useState([]);
  const [status, setStatus] = useState("ai");
  const [loading, setLoading] = useState(true);

  // Ha nincs conversationId, hozzuk létre
  useEffect(() => {
    const initConversation = async () => {
      if (!conversationId) {
        const conv = await createConversation();
        if (!conv?.id) {
          console.error("Conversation creation failed", conv);
          return;
        }
        setConversationId(conv.id);
      }
    };
    initConversation();
  }, [conversationId]);

  // Betöltjük a conversation üzeneteket
  useEffect(() => {
    if (!conversationId) return;
    setLoading(true);
    getConversation(conversationId).then(data => {
      setMessages(data.messages);
      setStatus(data.status);
      setLoading(false);
    });
  }, [conversationId]);

  const handleSend = async (text) => {
    if (!conversationId) return;
    // Add user message immediately
    setMessages(prev => [...prev, { id: Date.now(), sender: "user", text }]);
    // Add bot message placeholder
    const botMsgId = Date.now() + 1;
    setMessages(prev => [...prev, { id: botMsgId, sender: "bot", text: "" }]);
    try {
      let accumulated = "";
      await sendMessageStream(conversationId, text, (chunk, full) => {
        accumulated = full;
        setMessages(prev => prev.map(m =>
          m.id === botMsgId ? { ...m, text: accumulated } : m
        ));
      });
    } catch (error) {
      const message = error?.message || "Hiba tortent az uzenet kuldesekor.";
      setMessages(prev => prev.map(m =>
        m.id === botMsgId ? { ...m, text: message } : m
      ));
    }
  };

  const handleSwitchToHuman = async () => {
    if (!conversationId) return;
    await switchToHuman(conversationId);
    setStatus("human");
  };

  if (loading) return <div>Betöltés...</div>;

  return (
    <div className="chat-window">
      <div className="chat-messages">
        {messages.map(m => (
          <div
            key={m.id}
            className={`message-bubble ${m.sender === "user" ? "user" : "bot"}`}
          >
            {m.text}
          </div>
        ))}
      </div>
      {status === "ai" && (
        <button onClick={handleSwitchToHuman}>Átváltás emberre</button>
      )}
      <MessageInput onSend={handleSend} />
    </div>
  );
}

